import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

export interface IRegistration {
  selective_process_id: string;
  selective_process_name: 'Resource finish present success.';
  registration: IRegistrationsProps;
  is_cultural_house: boolean;
  allow_filter_vacancy_tree: boolean;
  candidate_dashboard: string;
  is_legacy: boolean;
}

interface IExamSchedule {
  duration_minutes: number;
  exam_schedule_date: string;
  exam_schedule_end_time: string;
  exam_schedule_id: string;
  exam_schedule_room_name: string;
  exam_schedule_start_time: string;
  exam_type: string;
  instructions: string;
}

export interface IAnnouncementStagesConvocations {
  candidate_allocation_id: string;
  candidate_exam_schedule: IExamSchedule;
  convocation_field_caption: string;
  datetime_for_divulgation_step: string;
  id: string;
  name: string;
  show_test_location: boolean;
  text_alert_of_convocation_card: string;
  receive_self_declaration_documents: boolean;
  receive_self_declaration_documents_start: string | null;
  receive_self_declaration_documents_end: string | null;
  document_upload_required?: boolean;
  process_key?: string;
  window_start?: string | null;
  window_end?: string | null;
}

export interface IRegistrationsProps {
  registration_id: string;
  registration_code: number; //ALTERADO
  vacancy_name: string;
  registration_date: string;
  status: string;
  actions: IActions;
  announcement_stages_convocations: IAnnouncementStagesConvocations[];
  second_vacancy: string;
  candidate_attachments?: ICandidateAttachment[];
}

export interface IActions {
  second_billing_statement: boolean;
  speciall_condition: boolean;
  change_type: boolean;
  has_result: boolean;
  social_name: boolean;
  show_test_location?: boolean;
  result_test: string;
  has_matriculation: string;
  can_update_registration: boolean;
  show_biopsicossocial_process: string;
  show_heteroidentification_process: string;
  show_titles_process: string;
  documents: ILabelAndUrl[];
  convocation_objective_test: string;
  convocation_biopsicossocial_process: string;
  convocation_dissertative_test: string;
  convocation_essay_test: string;
  convocation_heteroidentification_process: string;
  convocation_physical_aptitude_test: string;
  convocation_technical_aptitude_test: string;
  convocation_titles_process: string;
  convocation_delivery_project_documentation_materials_process: string;
  show_pppiq_form: boolean;
  receive_self_declaration_documents_start: string | null;
  receive_self_declaration_documents_end: string | null;
}

export interface ILabelAndUrl {
  label: string;
  url: string;
}

export interface ICandidateAttachment {
  id: string;
  document_name: string;
  file_url: string;
}

const RequestMyRegistrations = async () => {
  const response = await configApi.get<IRegistration[]>('candidate-area/candidate/');
  return response.data;
};

export const useRequestMyRegistration = () => {
  return useQuery({
    queryKey: ['my_registration'],
    queryFn: RequestMyRegistrations,
    refetchOnWindowFocus: false,
    gcTime: 0,
  });
};
